import * as React from "react";
const SvgSoplisticons = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path d="M2 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M9 10v3c0 1.474-.81 2.75-2 3.444V23a1 1 0 1 1-2 0v-6H4v6a1 1 0 1 1-2 0v-6.556C.81 15.75 0 14.474 0 13v-3c0-2.206 1.794-4 4-4h1c2.206 0 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h1c1.103 0 2-.897 2-2zm7-6a1 1 0 1 0 0-2c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3a1 1 0 1 0 0-2 1 1 0 0 1-1-1v-6h1a1 1 0 1 0 0-2h-1V5c0-.552.449-1 1-1m7.821.953a1.795 1.795 0 0 1-2.59-.011l-.962-1.01a.996.996 0 1 1 1.459-1.359l.805.835 2.683-2.72a2.5 2.5 0 0 0-1.715-.689h-2a2.5 2.5 0 0 0-2.5 2.5v2a2.5 2.5 0 0 0 2.5 2.5h2a2.5 2.5 0 0 0 2.5-2.5v-1.76l-2.179 2.214Zm-2.59 8.489-.962-1.01a.996.996 0 1 1 1.459-1.359l.805.835 2.683-2.72a2.5 2.5 0 0 0-1.715-.689h-2a2.5 2.5 0 0 0-2.5 2.5v2a2.5 2.5 0 0 0 2.5 2.5h2a2.5 2.5 0 0 0 2.5-2.5v-1.76l-2.179 2.214a1.795 1.795 0 0 1-2.59-.011Zm0 8.5-.962-1.01a.996.996 0 1 1 1.459-1.359l.805.835 2.683-2.72a2.5 2.5 0 0 0-1.715-.689h-2a2.5 2.5 0 0 0-2.5 2.5v2a2.5 2.5 0 0 0 2.5 2.5h2a2.5 2.5 0 0 0 2.5-2.5v-1.76l-2.179 2.214a1.795 1.795 0 0 1-2.59-.011Z" />
  </svg>
);
export default SvgSoplisticons;
